"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfTypeHintName = exports.SdtfRhinoTypeHintName = exports.SdtfGrasshopperTypeHintName = exports.SdtfGeometryTypeHintName = exports.SdtfPrimitiveTypeHintName = void 0;
var SdtfPrimitiveTypeHintName;
(function (SdtfPrimitiveTypeHintName) {
    SdtfPrimitiveTypeHintName["BOOLEAN"] = "boolean";
    SdtfPrimitiveTypeHintName["CHAR"] = "char";
    SdtfPrimitiveTypeHintName["COLOR"] = "color";
    SdtfPrimitiveTypeHintName["DATA"] = "data";
    SdtfPrimitiveTypeHintName["DECIMAL"] = "decimal";
    SdtfPrimitiveTypeHintName["DOUBLE"] = "double";
    SdtfPrimitiveTypeHintName["GUID"] = "guid";
    SdtfPrimitiveTypeHintName["IMAGE"] = "image";
    SdtfPrimitiveTypeHintName["INT8"] = "int8";
    SdtfPrimitiveTypeHintName["INT16"] = "int16";
    SdtfPrimitiveTypeHintName["INT32"] = "int32";
    SdtfPrimitiveTypeHintName["INT64"] = "int64";
    SdtfPrimitiveTypeHintName["JSON"] = "json";
    SdtfPrimitiveTypeHintName["SINGLE"] = "single";
    SdtfPrimitiveTypeHintName["STRING"] = "string";
    SdtfPrimitiveTypeHintName["UINT8"] = "uint8";
    SdtfPrimitiveTypeHintName["UINT16"] = "uint16";
    SdtfPrimitiveTypeHintName["UINT32"] = "uint32";
    SdtfPrimitiveTypeHintName["UINT64"] = "uint64";
})(SdtfPrimitiveTypeHintName || (exports.SdtfPrimitiveTypeHintName = SdtfPrimitiveTypeHintName = {}));
var SdtfGeometryTypeHintName;
(function (SdtfGeometryTypeHintName) {
    SdtfGeometryTypeHintName["GEOMETRY_ARC"] = "geometry.arc";
    SdtfGeometryTypeHintName["GEOMETRY_BOUNDING_BOX"] = "geometry.boundingbox";
    SdtfGeometryTypeHintName["GEOMETRY_BOX"] = "geometry.box";
    SdtfGeometryTypeHintName["GEOMETRY_CIRCLE"] = "geometry.circle";
    SdtfGeometryTypeHintName["GEOMETRY_COMPLEX"] = "geometry.complex";
    SdtfGeometryTypeHintName["GEOMETRY_CONE"] = "geometry.cone";
    SdtfGeometryTypeHintName["GEOMETRY_CYLINDER"] = "geometry.cylinder";
    SdtfGeometryTypeHintName["GEOMETRY_ELLIPSE"] = "geometry.ellipse";
    SdtfGeometryTypeHintName["GEOMETRY_INTERVAL"] = "geometry.interval";
    SdtfGeometryTypeHintName["GEOMETRY_INTERVAL2"] = "geometry.interval2";
    SdtfGeometryTypeHintName["GEOMETRY_LINE"] = "geometry.line";
    SdtfGeometryTypeHintName["GEOMETRY_MATRIX"] = "geometry.matrix";
    SdtfGeometryTypeHintName["GEOMETRY_PLANE"] = "geometry.plane";
    SdtfGeometryTypeHintName["GEOMETRY_POINT"] = "geometry.point";
    SdtfGeometryTypeHintName["GEOMETRY_POINT2D"] = "geometry.point2d";
    SdtfGeometryTypeHintName["GEOMETRY_POINT3D"] = "geometry.point3d";
    SdtfGeometryTypeHintName["GEOMETRY_POINT4D"] = "geometry.point4d";
    SdtfGeometryTypeHintName["GEOMETRY_POLYLINE"] = "geometry.polyline";
    SdtfGeometryTypeHintName["GEOMETRY_RAY"] = "geometry.ray";
    SdtfGeometryTypeHintName["GEOMETRY_RECTANGLE"] = "geometry.rectangle";
    SdtfGeometryTypeHintName["GEOMETRY_SPHERE"] = "geometry.sphere";
    SdtfGeometryTypeHintName["GEOMETRY_TORUS"] = "geometry.torus";
    SdtfGeometryTypeHintName["GEOMETRY_TRANSFORM"] = "geometry.transform";
    SdtfGeometryTypeHintName["GEOMETRY_TRANSFORM_LIST"] = "geometry.transformlist";
    SdtfGeometryTypeHintName["GEOMETRY_VECTOR"] = "geometry.vector";
    SdtfGeometryTypeHintName["GEOMETRY_VECTOR2D"] = "geometry.vector2d";
    SdtfGeometryTypeHintName["GEOMETRY_VECTOR3D"] = "geometry.vector3d";
    SdtfGeometryTypeHintName["GEOMETRY_VECTOR4D"] = "geometry.vector4d";
})(SdtfGeometryTypeHintName || (exports.SdtfGeometryTypeHintName = SdtfGeometryTypeHintName = {}));
var SdtfGrasshopperTypeHintName;
(function (SdtfGrasshopperTypeHintName) {
    SdtfGrasshopperTypeHintName["GRASSHOPPER_PATH"] = "grasshopper.path";
})(SdtfGrasshopperTypeHintName || (exports.SdtfGrasshopperTypeHintName = SdtfGrasshopperTypeHintName = {}));
var SdtfRhinoTypeHintName;
(function (SdtfRhinoTypeHintName) {
    SdtfRhinoTypeHintName["RHINO_ARC_CURVE"] = "rhino.arccurve";
    SdtfRhinoTypeHintName["RHINO_BREP"] = "rhino.brep";
    SdtfRhinoTypeHintName["RHINO_CURVE"] = "rhino.curve";
    SdtfRhinoTypeHintName["RHINO_EXTRUSION"] = "rhino.extrusion";
    SdtfRhinoTypeHintName["RHINO_LINE_CURVE"] = "rhino.linecurve";
    SdtfRhinoTypeHintName["RHINO_MESH"] = "rhino.mesh";
    SdtfRhinoTypeHintName["RHINO_NURBS_CURVE"] = "rhino.nurbscurve";
    SdtfRhinoTypeHintName["RHINO_NURBS_SURFACE"] = "rhino.nurbssurface";
    SdtfRhinoTypeHintName["RHINO_PLANE_SURFACE"] = "rhino.planesurface";
    SdtfRhinoTypeHintName["RHINO_POINT"] = "rhino.point";
    SdtfRhinoTypeHintName["RHINO_POLY_CURVE"] = "rhino.polycurve";
    SdtfRhinoTypeHintName["RHINO_POLYLINE_CURVE"] = "rhino.polylinecurve";
    SdtfRhinoTypeHintName["RHINO_REV_SURFACE"] = "rhino.revsurface";
    SdtfRhinoTypeHintName["RHINO_SUBD"] = "rhino.subd";
    SdtfRhinoTypeHintName["RHINO_SURFACE"] = "rhino.surface";
})(SdtfRhinoTypeHintName || (exports.SdtfRhinoTypeHintName = SdtfRhinoTypeHintName = {}));
exports.SdtfTypeHintName = Object.assign(Object.assign(Object.assign(Object.assign({}, SdtfPrimitiveTypeHintName), SdtfGeometryTypeHintName), SdtfGrasshopperTypeHintName), SdtfRhinoTypeHintName);
//# sourceMappingURL=SdtfShapeDiverTypeHints.js.map